{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Mejorar",
    "navBilling": "Facturación"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Tu pestaña. Tu <em>dhikr</em>.<br />Elevado.",
    "subtitle": "Todas las funciones que necesitas para un día más intencional — desde horarios de oración y reflexión de versículos con IA hasta el clima y las tareas prioritarias — en una nueva pestaña serena y hermosa.",
    "comparison_aria": "Comparación de planes",
    "free": {
      "tierLabel": "Actual",
      "tierName": "Free",
      "freeLabel": "Siempre gratis",
      "list_aria": "Funciones del plan Free"
    },
    "pro": {
      "list_aria": "Funciones del plan Pro",
      "tierLabel": "Mejorar a",
      "tierName": "Pro",
      "pricePeriod": "/ mes",
      "priceAlt": "o $39.99 / año"
    },
    "freeFeatures": {
      "clockDate": "Reloj y fecha",
      "verseOfDay": "Versículo del Quran del día",
      "dailyBackground": "Foto de fondo diaria",
      "qiblaCompass": "Brújula de la Qibla",
      "basicTasks": "Tareas básicas"
    },
    "proFeatures": {
      "weatherForecast": "Pronóstico del clima de 5 días",
      "verseFavorites": "Guardar y explorar versículos favoritos",
      "notesAi": "Notas con análisis de IA",
      "priorityTasks": "Gestión de tareas con prioridad",
      "verseReflection": "Reflexión de versículos con IA"
    },
    "plans": {
      "monthly": {
        "label": "Mensual",
        "price": "$4.99",
        "period": "/ mes",
        "note": "Facturación mensual"
      },
      "yearly": {
        "label": "Anual",
        "price": "$39.99",
        "period": "/ año",
        "note": "Dos meses gratis",
        "badge": "Ahorra 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Cancela cuando quieras. Tu acceso continúa hasta el final del período de facturación sin cargos parciales.",
    "billingPeriod_aria": "Período de facturación",
    "cta": "Continuar al pago seguro",
    "ctaLoading": "Redirigiendo al pago…",
    "promoManual": "Introduce el código {{code}} en la página siguiente para obtener tu descuento.",
    "signingUpAs": "Registrándote como {{account}}",
    "trustSignals_aria": "Señales de confianza",
    "reassurance": {
      "secureCheckout": "Pago seguro mediante Stripe",
      "cancelAnytime": "Cancela cuando quieras, sin preguntas",
      "accessUntilEnd": "Acceso hasta el final del período"
    },
    "errors": {
      "restoreSession": "No se pudo restaurar tu sesión. Inténtalo de nuevo desde la extensión.",
      "checkoutFailed": "No se pudo iniciar el pago. Inténtalo de nuevo."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Funciones desbloqueadas",
    "unlockedFeatures": {
      "weatherForecast": "Pronóstico del clima de 5 días",
      "verseFavorites": "Guardar y explorar versículos favoritos",
      "notesAi": "Notas con análisis de IA",
      "priorityTasks": "Gestión de tareas con prioridad",
      "verseReflection": "Reflexión de versículos con IA"
    },
    "success": {
      "title": "Bienvenido a Pro",
      "desc": "Tu suscripción está activa. Vuelve a la extensión para encontrar todas las funciones Pro esperándote.",
      "viewBilling": "Ver detalles de facturación",
      "closeTab": "Cerrar esta pestaña"
    },
    "cancel": {
      "title": "Pago cancelado",
      "desc": "No te preocupes — tu plan no cambió y no se te ha cobrado. Puedes mejorar cuando estés listo.",
      "backToUpgrade": "Volver a mejorar",
      "returnToExtension": "Volver a la extensión"
    }
  },
  "billing": {
    "title": "Facturación",
    "subtitle": "Gestiona tu suscripción y consulta el historial de pagos.",
    "subscription_aria": "Estado de la suscripción",
    "subscriptionTitle": "Suscripción",
    "loading_aria": "Cargando información de facturación",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "Activa",
      "trialing": "Prueba gratuita",
      "past_due": "Pago vencido",
      "unpaid": "Sin pagar",
      "canceled": "Cancelada",
      "incomplete": "Incompleta",
      "none": "Sin suscripción"
    },
    "planValues": {
      "proYearly": "Pro · Anual",
      "proMonthly": "Pro · Mensual"
    },
    "warnings": {
      "paymentFailedTitle": "Pago fallido",
      "paymentFailedDesc": "Tu último pago no se procesó. Actualiza tu método de pago mediante Gestionar facturación para mantener el acceso Pro.",
      "trialEndingTitle": "La prueba termina pronto",
      "trialEndingToday": "Tu prueba gratuita termina hoy, el {{date}}. Añade un método de pago para mantener tus funciones Pro.",
      "trialEndingInDays_one": "Tu prueba gratuita termina en {{count}} día, el {{date}}. Añade un método de pago para mantener tus funciones Pro.",
      "trialEndingInDays_other": "Tu prueba gratuita termina en {{count}} días, el {{date}}. Añade un método de pago para mantener tus funciones Pro."
    },
    "cancellationScheduled": "Cancelación programada. Conservas el acceso completo a Pro hasta el <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "La prueba termina hoy",
      "trialDaysRemaining_one": "{{count}} día restante en la prueba",
      "trialDaysRemaining_other": "{{count}} días restantes en la prueba",
      "renews": "Se renueva el {{date}}",
      "accessUntil": "Acceso hasta el {{date}}"
    },
    "kv": {
      "status": "Estado",
      "nextRenewal": "Próxima renovación",
      "trialEnds": "La prueba termina",
      "trialDaysLeft_one": "{{count}} día restante",
      "trialDaysLeft_other": "{{count}} días restantes",
      "endsToday": "termina hoy",
      "plan": "Plan"
    },
    "upgradeNudge": {
      "title": "Desbloquea las funciones Pro",
      "desc": "Clima, horarios de oración, reflexión de versículos con IA y más — $4.99/mes o $39.99/año.",
      "cta": "Mejorar"
    },
    "actions": {
      "manageBilling": "Gestionar facturación y método de pago",
      "cancelConfirmTitle": "¿Cancelar tu suscripción?",
      "cancelConfirmDesc": "Conservarás el acceso completo a Pro hasta el final de tu período de facturación actual. No se emiten reembolsos parciales.",
      "canceling": "Cancelando…",
      "yesCancel": "Sí, cancelar",
      "keepPro": "Mantener Pro",
      "cancelSubscription": "Cancelar suscripción"
    },
    "noSubscription": "No se encontró ninguna suscripción.",
    "paymentHistory_aria": "Historial de pagos",
    "paymentHistoryTitle": "Historial de pagos",
    "invoices_aria": "Facturas",
    "invoiceView": "Ver",
    "invoiceView_aria": "Ver factura del {{date}}",
    "noInvoices": "Aún no hay facturas.",
    "dangerZone_aria": "Zona de peligro",
    "dangerZoneTitle": "Zona de peligro",
    "deleteAccountTitle": "Eliminar cuenta",
    "deleteAccountDesc": "Elimina permanentemente tu cuenta y todos los datos asociados — tareas, notas, favoritos e historial de facturación. Esta acción no se puede deshacer.",
    "deleteAccountBtn": "Eliminar cuenta",
    "deleteConfirm": {
      "warning": "Esto, de forma inmediata y permanente:",
      "list": {
        "deleteContent": "Eliminará todas tus tareas, notas y versículos favoritos",
        "cancelSubscription": "Cancelará cualquier suscripción activa (sin reembolso por el tiempo no utilizado)",
        "removeAccount": "Eliminará tu cuenta de nuestra base de datos",
        "signOut": "Cerrará tu sesión en todos los dispositivos"
      },
      "typeToConfirm": "Escribe <strong>DELETE</strong> para confirmar",
      "inputPlaceholder": "DELETE",
      "deleting": "Eliminando…",
      "confirmBtn": "Eliminar mi cuenta permanentemente",
      "cancelBtn": "Cancelar"
    },
    "errors": {
      "loadFailed": "No se pudo cargar la información de facturación.",
      "cancelFailed": "No se pudo cancelar la suscripción.",
      "deleteFailed": "No se pudo eliminar la cuenta. Inténtalo de nuevo o contacta con soporte.",
      "portalFailed": "No se pudo abrir el portal de facturación."
    }
  },
  "privacy": {
    "tocLabel": "Política de privacidad",
    "toc_aria": "Tabla de contenidos",
    "lastUpdated": "Última actualización<br />22 de septiembre de 2026",
    "sections": {
      "overview": "Resumen",
      "informationWeCollect": "Información que recopilamos",
      "connectedServices": "Servicios conectados (Google, Todoist, Apple)",
      "howWeUse": "Cómo usamos tu información",
      "howWeShare": "Cómo compartimos tu información",
      "dataRetention": "Retención de datos",
      "yourRights": "Tus derechos de privacidad",
      "california": "Residentes de California (CCPA/CPRA)",
      "cookies": "Cookies y almacenamiento local",
      "security": "Seguridad de los datos",
      "changes": "Cambios en esta política",
      "contact": "Contáctanos"
    },
    "headings": {
      "informationWeCollect": "Información que recopilamos",
      "connectedServices": "Servicios conectados (Google, Todoist, Apple)",
      "howWeUse": "Cómo usamos tu información",
      "howWeShare": "Cómo compartimos tu información",
      "dataRetention": "Retención de datos",
      "yourRights": "Tus derechos de privacidad",
      "california": "Residentes de California (CCPA / CPRA)",
      "cookies": "Cookies y almacenamiento local",
      "security": "Seguridad de los datos",
      "changes": "Cambios en esta política",
      "contact": "Contáctanos"
    }
  },
  "deleteAccount": {
    "intro": "Eliminar tu cuenta borra permanentemente:",
    "list": {
      "account": "Tu cuenta y tu perfil",
      "tasks": "Todas las tareas",
      "notes": "Todas las notas",
      "verses": "Versículos guardados",
      "billing": "Los registros de suscripción"
    },
    "irreversible": "Esta acción no se puede deshacer.",
    "appleNotice": "Eliminar tu cuenta no cancela una suscripción comprada a través del App Store. Cancélala también en Ajustes → Apple ID → Suscripciones.",
    "manageSubscription": "Gestionar suscripción",
    "continueBtn": "Continuar con la eliminación",
    "keepBtn": "Conservar mi cuenta",
    "confirmTitle": "¿Eliminar tu cuenta?",
    "confirmDesc": "Tu cuenta y todos sus datos se eliminarán permanentemente. Esta acción no se puede deshacer.",
    "confirmBtn": "Eliminar mi cuenta permanentemente",
    "deleting": "Eliminando…",
    "error": "No pudimos eliminar tu cuenta. Comprueba tu conexión e inténtalo de nuevo."
  }
}
